import { LeftOutlined, RightCircleOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { Badge, Button } from "antd";
import { useHistory } from "react-router";
import NewAndPreparedCart from "./NewAndPreparedCart";


const PosCart=({cartData, cartItems,addCount,menudata,handleCheckboxChange,proccedToCheckout,type,setType,setViewCartSeletion})=>{

    const history = useHistory();

    return(
        <div>
            <div className="pos-table-header" >
              <Button style={{fontSize:"22px",marginBottom:"10px"}}  icon={<LeftOutlined />} type="text" onClick={()=>setViewCartSeletion(false)}>
                Table no :{localStorage.getItem("tableNumber")}</Button>
                
                <Badge
      count={cartData?.cart_items?.length ??  0}
      size="small"
      offset={[6, -2]}
      style={{
        backgroundColor: "#CB324C",
        color: "#fff",
        minWidth: 13,
        height: 13,
        lineHeight: "13px",
        fontSize: 10,
        borderRadius: "50%",
        padding: 0,
      }}
    >
      <ShoppingCartOutlined style={{ fontSize: 22,color:"#CB324C" }} />
    </Badge>
    </div>

<NewAndPreparedCart cartItems={cartItems} addCount={addCount} menudata={menudata} handleCheckboxChange={handleCheckboxChange}
type ={type} setType={setType}
/>
    <div className="bottom-fixed-wrapper">
      

      {/* Cart Section */}
      <div className="cart-bar">
        <div className="cart-left">
          <span className="items">{cartData?.cart_items?.length} Items</span>
          <span className="price mobile-price">${cartData?.price ?? 0}</span>
        </div>

        <div className="cart-right" onClick={()=>proccedToCheckout(type)}>
          <span>Place Order</span>
          <RightCircleOutlined />
        </div>
      </div>
    </div>

             
        </div>
    )
}
export default PosCart;